import { Avatar, Box, IconButton, Typography, useTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import { useState } from "react";
import { KeyboardArrowDown, Logout as LogoutIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CommonPaths } from "../Routes/Paths";
import { logout } from "../Store/auth/authSlice";
import { resetState } from "../Store/common/commonSlice";

const Settings = () => {
  const { SIGNIN_PATH } = CommonPaths;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    navigate(SIGNIN_PATH, { replace: true });
    dispatch(logout());
    dispatch(resetState());
  };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <IconButton
        sx={{ p: 0, marginTop: '20px', marginLeft: '10px' }}
        onClick={handleOpenDialog}
      >
        <LogoutIcon sx={{ color: '#ffffff', fontSize: '34px' }} />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">{"Confirm Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            No
          </Button>
          <Button onClick={handleLogout} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Settings;
